import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex flex-row flex-wrap" }

import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import CheckBoxWithLabel from "@/components/Form/Common/CheckBoxWithLabel.vue";
import ErrorText from "@/components/Texts/ErrorText.vue";
import { computed, ComputedRef } from "vue";
import { useGameStore } from "@/Store/useGameStore";
import Category from "@/Interfaces/Category";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditCategories',
  setup(__props) {

const gameStore = useGameStore();

const selectedCategories: ComputedRef<number[]> = computed(() => {
  return gameStore.selectedCategories;
});

const allCategories: ComputedRef<Category[]> = computed(() => {
  return gameStore.allCategories;
});

const errorCategories = computed(() => {
  return gameStore.errors.find((error) => error.path.includes("categories"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PrimaryLabel, {
      text: `Catégories sélectionnées : ${selectedCategories.value.length}`,
      class: "mb-2 text-left"
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allCategories.value, (category) => {
        return (_openBlock(), _createElementBlock("div", {
          key: category.id
        }, [
          _createVNode(CheckBoxWithLabel, {
            value: category.id,
            name: category.name,
            is_required: true,
            modelValue: selectedCategories.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCategories).value = $event)),
            color: category.color,
            color2: category.color2,
            class: "mb-4 mr-4"
          }, null, 8, ["value", "name", "modelValue", "color", "color2"])
        ]))
      }), 128))
    ]),
    (errorCategories.value)
      ? (_openBlock(), _createBlock(ErrorText, {
          key: 0,
          text: errorCategories.value.message,
          class: "mt-2 text-left"
        }, null, 8, ["text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})